import { render } from "./Verify.vue?vue&type=template&id=0c954c3c&scoped=true"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"

import "./Verify.vue?vue&type=style&index=0&id=0c954c3c&scoped=true&lang=css"

import exportComponent from "C:\\workspaces\\HGAccount\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c954c3c"]])

export default __exports__